import Slider from "react-slick";

const TestimonialSlider = () => {
    const sliderSettings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <>
            <Slider {...sliderSettings}>
                <div className="testimonial-block d-flex">
                    <div className="avatar">
                        <img src="assets/images/matre.svg" alt="" />
                    </div>
                    <div className="testimonial-meta pl-5">
                        <h4 className="h4-style mb-2">Mr Uday</h4>
                        <div className="para-txt txt-large">
                            <p>The entire team of RSS has show exceptional Dedication, Professionalism & commitment to lead to successful completion of project.</p>
                        </div>
                    </div>
                </div>
                <div className="testimonial-block d-flex">
                    <div className="avatar">
                        <img src="assets/images/bn.png" alt="" />
                    </div>
                    <div className="testimonial-meta pl-5">
                        <h4 className="h4-style mb-2">Mr BN Mishra</h4>
                        <div className="para-txt txt-large">
                            <p>We acknowledge efforts put by RSS. At all stages of work, resources deployed, co-operation extended for satisfactory & safe working and completing our project.</p>
                        </div>
                    </div>
                </div>
            </Slider>
        </>
    )
}

export default TestimonialSlider;